import { Button, InputIcon } from '@platform/ui-library';
import type { InputIconProps } from '@platform/ui-library/build/InputIcon/types';
import type { FormEvent } from 'react';
import styles from './AddForm.module.scss';

interface AddFormProps<T extends string> {
  type: T;
  label?: string;
  disabled?: boolean;
  placeholder?: string;
  icon?: InputIconProps['icon'];
  onSubmit: (item: string) => void;
  className?: string;
}

export default function AddForm<T extends string = string>(props: AddFormProps<T>) {
  const inputName = `${props.type}Name`;
  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const input = e.currentTarget.elements.namedItem(
      inputName
    ) as HTMLInputElement;
    if (input) {
      props.onSubmit(input.value);
      input.value = '';
    }
  };

  return (
    <form onSubmit={onSubmit} className={`${styles.container} ${props.className || ''}`}>
      {/* TODO: This should be an autocomplete [?] */}
      <InputIcon
        required
        disabled={props.disabled}
        name={inputName}
        icon={props.icon}
        placeholder={props.placeholder || `Add ${props.type}`}
        label={props.label}
        outerClass={styles.containerInputOutterWrapper}
        extraClasses={styles.containerInputWrapper}
        className={styles.containerInput}
      />
      <Button
        type="submit"
        tabIndex={-1}
        disabled={props.disabled}
        className="ui-button-round"
        icon="plus"
        theme="outline"
      />
    </form>
  );
}
